import React from 'react';
import { Hooks } from '@3nickels/data-modules';
import { PlaidEmbeddedLink } from 'react-plaid-link';

type PlaidEmbeddedInstitutionSearchProps = {
  onExit: () => void;
  onSuccess: (publicToken: string) => Promise<void> | void;
  plaidContextToken: string | null;
  wizard: ReturnType<typeof Hooks.usePlaidWizard>;
};

const PlaidEmbeddedInstitutionSearch: React.FC<PlaidEmbeddedInstitutionSearchProps> = ({
  onExit,
  onSuccess,
  plaidContextToken,
}) => {
  if (!plaidContextToken) {
    return null;
  }

  return (
    <div
      style={{
        marginLeft: '-4px',
        marginRight: '-4px',
        paddingBottom: '10px',
        width: 'calc(100% + 8px)',
      }}>
      <PlaidEmbeddedLink
        onExit={onExit}
        onSuccess={async (publicToken: string) => {
          await onSuccess(publicToken);
        }}
        style={{ border: 0, height: '420px', width: '100%' }}
        token={plaidContextToken}
      />
    </div>
  );
};

export default React.memo(PlaidEmbeddedInstitutionSearch);
